import { createRoot } from 'react-dom/client';
import App from './components/App';
import Maintenance from './components/Maintenance';
import './index.css';

// MAINTENANCE GATE: env-controlled. Defaults to OFF (app visible); set VITE_MAINTENANCE_MODE=true
// at build time to show the maintenance page (e.g. while a prod issue is being investigated).
const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(MAINTENANCE_MODE ? <Maintenance /> : <App />);
